(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glint-customer-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glint-real-walls')) {
    customElements.define('glint-real-walls', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        const rail = this.querySelector('.glint-real-walls__rail');
        const cards = [...this.querySelectorAll('.glint-real-walls__card')];
        const arrows = [...this.querySelectorAll('[data-direction]')];
        const progress = this.querySelector('.glint-real-walls__progress span');
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          arrows.forEach(button => { button.hidden = max < 2; button.disabled = Number(button.dataset.direction) < 0 ? rail.scrollLeft < 2 : rail.scrollLeft >= max - 2; });
          const visible = Math.min(1, rail.clientWidth / rail.scrollWidth);
          progress.style.width = `${visible * 100}%`;
          progress.style.marginLeft = `${max > 0 ? (rail.scrollLeft / max) * (1 - visible) * 100 : 0}%`;
        };
        arrows.forEach(button => button.addEventListener('click', () => {
          const distance = (cards[0]?.getBoundingClientRect().width || rail.clientWidth) + parseFloat(getComputedStyle(rail).gap || 0);
          rail.scrollBy({ left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, opts));
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .2 });
        cards.forEach(card => {
          const video = card.querySelector('video'), button = card.querySelector('.glint-real-walls__play');
          video.controls = false;
          video.muted = true;
          button.hidden = false;
          button.addEventListener('click', async () => {
            if (!video.src) video.src = video.dataset.src;
            video.muted = true;
            try { await video.play(); } catch { button.hidden = false; video.controls = true; }
          }, opts);
          video.addEventListener('play', () => {
            document.querySelectorAll('glint-real-walls video').forEach(other => { if (other !== video) other.pause(); });
            video.controls = true; button.hidden = true;
          }, opts);
          video.addEventListener('pause', () => { button.hidden = false; video.controls = false; }, opts);
          this.observer.observe(video);
        });
        document.addEventListener('visibilitychange', () => { if (document.hidden) cards.forEach(card => card.querySelector('video').pause()); }, opts);
        rail.addEventListener('scroll', update, { passive: true, ...opts });
        this.resize = new ResizeObserver(update); this.resize.observe(rail); update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
